const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/workspaces/$id/settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQueryOptions } from '~/queries/me';
import { workspaceQueryOptions } from '~/queries/workspace';
export const Route = createFileRoute('/_authed/workspaces/$id/settings')({
  beforeLoad: async ({
    context,
    params
  }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    const workspace = await context.queryClient.ensureQueryData(workspaceQueryOptions(params.id));
    if (workspace.owner.id !== me.id) {
      throw redirect({
        to: '/workspaces/$id/nodes',
        params: {
          id: params.id
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface LabelFormProps {
  workspaceId: string;
  label: Label;
}
interface MiniGraphProps {
  label: Label;
}